import { render, staticRenderFns } from "./CalendarNavigation.vue?vue&type=template&id=18c3be67"
import script from "./CalendarNavigation.vue?vue&type=script&lang=js"
export * from "./CalendarNavigation.vue?vue&type=script&lang=js"
import style0 from "./CalendarNavigation.vue?vue&type=style&index=0&id=18c3be67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports